import { UserForm } from '../components/UserForm'

export function UserPage() {

    return (
        <div className="main-content">
            <UserForm />
        </div>
    )
}